import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'image',
    label: i18n('entities.image.fields.image'),
    schema: schemas.images(
      i18n('entities.image.fields.image'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'name',
    label: i18n('entities.image.fields.name'),
    schema: schemas.string(
      i18n('entities.image.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'info',
    label: i18n('entities.image.fields.info'),
    schema: schemas.string(
      i18n('entities.image.fields.info'),
      {},
    ),
  },
];